import { useAppSelector } from 'app-redux/hooks'

import { CardType } from 'types/deck'

import ArchidektDropdown from 'components/elements/ArchidektDropdown'
import Icon from 'components/elements/Icon'
import Checkbox from 'components/formElements/Checkbox'

import { makePrimary } from 'utils/CategoryChangeHelpers'

import styles from './simpleCategorySelection.module.scss'

type Props = {
  card: CardType
  disabled?: boolean
  onCardUpdated: (updatedCard: CardType) => void
}

const SimpleCategorySelection = ({ card, disabled, onCardUpdated }: Props) => {
  const categories = useAppSelector(state => state.deck.categories)

  const handleToggleCategory = (categoryName: string) => {
    if (card.categories.includes(categoryName) && card.categories.length)
      onCardUpdated({
        ...card,
        categories: card.categories.filter(currentCategoryName => categoryName !== currentCategoryName),
      })
    else
      onCardUpdated({
        ...card,
        categories: [...card.categories, categoryName],
      })
  }

  const handleMakePrimary = (categoryName: string, e?: React.MouseEvent) => {
    const updatedCategories = makePrimary(card.categories, categoryName, e?.ctrlKey)

    onCardUpdated({ ...card, categories: updatedCategories })
  }

  return (
    <ArchidektDropdown
      menuClassName={styles.menu}
      customOptionsTop={Object.values(categories)
        .sort((a, b) => (a.name > b.name ? 1 : -1))
        .map(category => (
          <span className={styles.option} key={category.name}>
            <Checkbox
              label={category.name}
              checked={card.categories.includes(category.name)}
              className={styles.checkbox}
              onChange={() => handleToggleCategory(category.name)}
            />
            <button onClick={e => handleMakePrimary(category.name, e)} className={styles.primaryButton}>
              <Icon
                color={category.name === card.categories[0] ? 'blue' : undefined}
                name={category.name === card.categories[0] ? 'star' : 'star outline'}
              />
            </button>
          </span>
        ))}>
      <button disabled={disabled} className={styles.trigger}>
        {card.categories.join(', ')} <Icon name="triangle down" />
      </button>
    </ArchidektDropdown>
  )
}

export default SimpleCategorySelection
